import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './share/header/header.component';
import { FooterComponent } from './share/footer/footer.component';
import { DefaultComponent } from './layout/default/default.component';
import { BannerComponent } from './components/home/banner/banner.component';
import { SearchComponent } from './components/home/search/search.component';
import { NewComponent } from './components/home/new/new.component';
import { PopularComponent } from './components/home/popular/popular.component';
import { RecommendedComponent } from './components/home/recommended/recommended.component';
import { TextComponent } from './components/home/text/text.component';
import { ExploreComponent } from './components/pages/explore/explore.component';
import { BulletinsComponent } from './components/home/bulletins/bulletins.component';
import { LinksComponent } from './components/home/links/links.component';
import { ReviewsComponent } from './components/home/reviews/reviews.component';
import { EBookComponent } from './components/home/e-book/e-book.component';
import { ResourceListComponent } from './components/home/resource-list/resource-list.component';
import { LocationHoursComponent } from './components/home/location-hours/location-hours.component';
import { QuickQaComponent } from './components/home/quick-qa/quick-qa.component';
import { HomepageComponent } from './components/home/homepage/homepage.component';
import { EventsComponent } from './components/home/events/events.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';


import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FullCalendarModule } from 'ng-fullcalendar';
import { BulletinsingleComponent } from './components/home/bulletinsingle/bulletinsingle.component';
import { ResourceListSingleComponent } from './components/home/resource-list-single/resource-list-single.component';
import { ReadingListComponent } from './components/pages/reading-list/reading-list.component';
import { NewinlibararyComponent } from './components/pages/newinlibarary/newinlibarary.component';
import { PopularListComponent } from './components/pages/popular-list/popular-list.component';
import { RecommendedListComponent } from './components/pages/recommended-list/recommended-list.component';
import { ExplorewgtComponent } from './components/home/explorewgt/explorewgt.component';
import { LibararyNewsComponent } from './components/pages/libarary-news/libarary-news.component';
import { AwardsComponent } from './components/pages/awards/awards.component';
import { ListComponent } from './components/searchlist/list/list.component';
import { Ng5SliderModule } from 'ng5-slider';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


import { StarRatingModule } from 'angular-star-rating';
import { DetailComponent } from './components/pages/detail/detail.component';
import { SplitCamelCase } from './split-camel-case-pipe';
import { HighlightSearch } from './test-highlight-pipe';
import { ChildThemetext } from './childThemetext-pipe';
import { RemoveHTML } from './removehtml-pipe';
import { AttributesToButtels } from './attributes-bulletinr-pipe';
import { HeaderinnerComponent } from './share/headerinner/headerinner.component';
import {NgxMaskModule} from 'ngx-mask';
import { ErrorComponent } from './error/error.component';
import { CookieService } from 'ngx-cookie-service';
import { InternalerrorComponent } from './internalerror/internalerror.component';
import { UserIdleModule } from 'angular-user-idle';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { EscapeHtmlPipe } from './keep-html.pipe';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { ForgotComponent } from './components/pages/forgot/forgot.component';

import { SortablejsModule } from 'ngx-sortablejs';

import { BulletinsListComponent } from './components/pages/bulletins-list/bulletins-list.component';
import { BulletinDetailComponent } from './components/pages/bulletin-detail/bulletin-detail.component';
import { DatepickerModule } from 'ng2-datepicker';
import { ReviewDetailComponent } from './components/pages/review-detail/review-detail.component';

import 'node_modules/froala-editor/js/plugins.pkgd.min';
import { ReviewSearchComponent } from './components/pages/review-search/review-search.component'
import { NotifierModule } from 'angular-notifier';
import { MyAccountComponent } from './components/settings/my-account/my-account.component';
import { ReplacePipe } from './replace.pipe';
import { PrintComponent } from './components/print/print.component';
import { DirectoryComponent } from './directory/directory.component';
import { ResetmailComponent } from './components/pages/resetmail/resetmail.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { HistoryComponent } from './components/settings/history/history.component';
import { UnsubscribeComponent } from './components/pages/unsubscribe/unsubscribe.component';
import { ListSummaryComponent } from './components/pages/list-summary/list-summary.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { LazyloadimageComponent } from './components/home/lazyloadimage/lazyloadimage.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { JwtInterceptor } from './@Core/interceptor/token.interceptor';
import { IdCardsComponent } from './components/pages/id-cards/id-cards.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    DefaultComponent,
    BannerComponent,
    SearchComponent,
    NewComponent,
    PopularComponent,
    RecommendedComponent,
    TextComponent,
    ExploreComponent,
    BulletinsComponent,
    LinksComponent,
    ReviewsComponent,
    EBookComponent,
    ResourceListComponent,
    LocationHoursComponent,
    QuickQaComponent,
    HomepageComponent,
    EventsComponent,
    BulletinsingleComponent,
    ResourceListSingleComponent,
    ReadingListComponent,
    NewinlibararyComponent,
    PopularListComponent,
    RecommendedListComponent,
    ExplorewgtComponent,
    LibararyNewsComponent,
    AwardsComponent,
    ListComponent,
    DetailComponent,
    SplitCamelCase,
    HighlightSearch,
    ChildThemetext,
    RemoveHTML,
    AttributesToButtels,
    HeaderinnerComponent,
    ErrorComponent,
    InternalerrorComponent,
    BulletinsListComponent,
    EscapeHtmlPipe, ForgotComponent, BulletinDetailComponent, ReviewDetailComponent, ReviewSearchComponent, MyAccountComponent ,
    ReplacePipe,
    PrintComponent,
    DirectoryComponent,
    ResetmailComponent,
    HistoryComponent,
   // StarRatingModule

    UnsubscribeComponent,
    ListSummaryComponent,
    LazyloadimageComponent,
    IdCardsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    ColorPickerModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SlickCarouselModule,
    FullCalendarModule,
    Ng5SliderModule,
    InfiniteScrollModule,
    StarRatingModule.forRoot(),
    NgxMaskModule.forRoot(),
    UserIdleModule.forRoot({idle: 300, timeout: 60, ping: 60}),
    DragDropModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    SortablejsModule,
    DatepickerModule,
    CommonModule,
    NgxBarcodeModule,
    LazyLoadImageModule,
    NotifierModule.withConfig( {
        theme: 'material',
        behaviour: {
            autoHide: 12000,
            onClick: false,
            onMouseover: 'pauseAutoHide',
            showDismissButton: true,
            stacking: 4
        },
        position: {
                horizontal: {
                position: 'right',
                distance: 12
            },
            vertical: {
                position: 'top',
                distance: 12,
                gap: 10

            }
        },
        animations: {
            enabled: true,
            show: {
                preset: 'slide',
                speed: 300,
                easing: 'ease'
            },
            hide: {
                preset: 'fade',
                speed: 300,
                easing: 'ease',
                offset: 50
            },
            shift: {
                speed: 300,
                easing: 'ease'
                },
            overlap: 150
        }
    })
  ],
  exports:[StarRatingModule],
  providers: [
    CookieService,
    {   provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
